import { z } from 'zod';

export const getImpactAnswersDtoSchema_ScenographyRecyclable = z.array(
  z.object({
    id: z.number(),
    userId: z.string(),
    projectId: z.number(),
    sector: z.string(),
    scenographieRecyclableType: z.string(),
    quantity: z.string().or(z.number()),
    isExternal: z.boolean(),
    label: z.string().nullable(),
    source: z.string().nullable(),
    score: z.number().optional(),
    tags: z
      .object({
        values: z
          .array(z.object({ id: z.number(), name: z.string() }))
          .optional(),
      })
      .optional(),
  }),
);

export type QuestionScenographyRecyclableDto = {
  id: number;
  userId: string;
  projectId: number;
  sector: string;
  scenographieRecyclableType: string;
  quantity: string | number;
  isExternal: boolean;
  label: string | null;
  source?: string | null;
  score?: number;
  tags?: { values?: Array<{ id: number; name: string }> };
};
